<template>
    <VJoyWrapper no-margin column-gap="1" class="price-indicator" wrap="nowrap">
        <VJoyIcon name="cost-plus" color="neutral-50" />
        <span v-if="priceVisibleOnDemand && isAdmin" data-testid="profile-price-visible-for-admin" v-html="displayedPrice"></span>
        <span v-else-if="priceVisibleOnDemand" data-testid="profile-price-not-visible">
            {{ $t('profile.numeral.infos.price.non.available') }}
        </span>
        <span v-else :class="{'price-indicator__text--bold': bold}" data-testid="profile-price" v-html="displayedPrice"></span>
        <slot name="price-hidden"></slot>

        <ClientOnly v-if="priceVisibleOnDemand && isAdmin">
            <VJoyTooltip text="Display admin info" placement="bottom" class="price-indicator__tooltip" data-testid="profile-price-admin-tooltip">
                <VJoyIcon name="eye" color="quaternary" class="price-indicator__tooltip-icon" />
                <template #tooltip-content>
                    <ul>
                        <li>hidden by choice : {{ props.priceHidden }}</li>
                        <li>hidden by vertical : {{ props.isStrategyProfile }}</li>
                    </ul>
                </template>
            </VJoyTooltip>
            <template #fallback>
                <VJoyFormFieldSkeleton size="xxsmall" width="16px" />
            </template>
        </ClientOnly>
    </VJoyWrapper>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {useHasEnoughPriviledge, useTranslation, useFormat} from '#imports';
    import {VJoyIcon, VJoyWrapper, VJoyTooltip, VJoyFormFieldSkeleton} from '@maltjoy/core-vue';

    const props = defineProps<{
        priceHidden?: boolean;
        currencyCode: string;
        price: number;
        isStrategyProfile: boolean;
        editMode?: boolean;
        bold?: boolean;
    }>();

    const {t} = useTranslation();
    const isAdmin = await useHasEnoughPriviledge(['ROLE_ADMIN']);

    const {formatAmount} = useFormat();
    const priceFormatted = computed(() => formatAmount(props.currencyCode, props.price));

    const priceVisibleOnDemand = computed(() => !props.editMode && (props.priceHidden || props.isStrategyProfile));

    const displayedPrice = computed(() =>
        t('profile.numeral.infos.price.amount', {
            0: priceFormatted.value,
        }),
    );
</script>

<style scoped lang="scss">
    .price-indicator {
        &__text--bold {
            font-weight: var(--joy-font-weight-bold);
        }

        &__tooltip {
            height: 16px;
        }

        &__tooltip-icon {
            cursor: pointer;
        }
    }
</style>
